<script>
  import { createEventDispatcher } from "svelte"
  import Button from "./Button.svelte"
  export let disabled = false
  const color = "var(--main-background-color)"
  const backgroundColor = "var(--main-color)"
  const dispatch = createEventDispatcher()
  function onClick() {
    if (disabled) return
    dispatch("click")
  }
</script>

<Button on:click={onClick} {disabled} {color} {backgroundColor}>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <path vector-effect="non-scaling-stroke" d="M15,9a6,6,0,1,1-1.15-3.53" />
    <polyline
      vector-effect="non-scaling-stroke"
      points="13.85 0.47 13.85 5.47 8.85 5.47"
    />
  </svg>
</Button>

<style>
  svg {
    display: block;
    height: 22px;
    fill: transparent;
    stroke: currentColor;
    stroke-width: 0.07em;
  }
</style>
